import { render, staticRenderFns } from "./RevenueOfficeWise.vue?vue&type=template&id=64f50328&"
import script from "./RevenueOfficeWise.vue?vue&type=script&lang=js&"
export * from "./RevenueOfficeWise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports